export const apiBaseUri = import.meta.env.VITE_API_URL || "";

export const userAuthPath = import.meta.env.VITE_AUTH_URI || "";

export const apiVersion = import.meta.env.VITE_API_VERSION || "";

export const azureLoginUri = import.meta.env.VITE_AZURE_SIGNIN_URI;

export const commonHeader = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

export const generateEndpoint = (path: string) => `${apiBaseUri}${apiVersion}${path}`;

// kintoneシステム関連エンドポイント（mainバックエンド経由）
export const kintoneSystemEndpoints = {
  // ジョブ一覧取得
  getKintoneSystemsByProject: (organizationId: string, projectId: string) =>
    `${apiBaseUri}${apiVersion}/organizations/${organizationId}/projects/${projectId}/kintone-systems`,
  // ジョブ詳細取得
  getKintoneSystem: (organizationId: string, projectId: string, kintoneSystemId: string) =>
    `${apiBaseUri}${apiVersion}/organizations/${organizationId}/projects/${projectId}/kintone-systems/${kintoneSystemId}`,
  // ジョブ進捗取得
  getKintoneSystemProgress: (organizationId: string, projectId: string, kintoneSystemId: string) =>
    `${apiBaseUri}${apiVersion}/organizations/${organizationId}/projects/${projectId}/kintone-systems/${kintoneSystemId}/progress`,
  // ジョブ開始
  startKintoneSystem: (organizationId: string, projectId: string) =>
    `${apiBaseUri}${apiVersion}/organizations/${organizationId}/projects/${projectId}/kintone-systems`,
  // ジョブキャンセル
  cancelKintoneSystem: (organizationId: string, projectId: string, kintoneSystemId: string) =>
    `${apiBaseUri}${apiVersion}/organizations/${organizationId}/projects/${projectId}/kintone-systems/${kintoneSystemId}/cancel`,
  // Kintone認証検証
  verifyKintoneAuth: (organizationId: string, projectId: string) =>
    `${apiBaseUri}${apiVersion}/organizations/${organizationId}/projects/${projectId}/kintone/verify-auth`,
};

// kintoneシステム管理者関連エンドポイント
export const kintoneAdminEndpoints = {
  getKintoneAdmin: (organizationId: string, projectId: string) =>
    `${apiBaseUri}${apiVersion}/organizations/${organizationId}/projects/${projectId}/kintone-admin`,
  createKintoneAdmin: (organizationId: string, projectId: string) =>
    `${apiBaseUri}${apiVersion}/organizations/${organizationId}/projects/${projectId}/kintone-admin`,
  deleteKintoneAdmin: (organizationId: string, projectId: string, adminId: string) =>
    `${apiBaseUri}${apiVersion}/organizations/${organizationId}/projects/${projectId}/kintone-admin/${adminId}`,
};

export const endpoints = {
  getOrganization: (id: string) => `${apiBaseUri}${apiVersion}/organization/${id}`,
  getRoleInOrganization: (id: string, userId: string) =>
    `${apiBaseUri}${apiVersion}/organization/${id}/role?user_id=${userId}`,
  updateOrganization: `${apiBaseUri}${apiVersion}/organization/update`,
  getAllProjects: (userId: string, organization_id: string) =>
    `${apiBaseUri}${apiVersion}/user/${userId}/projects?organization_id=${organization_id}`,
  userAuth: `${apiBaseUri}${userAuthPath}`,
  createProject: `${apiBaseUri}${apiVersion}/project`,
  getDocument: (id: string, projectId: string) =>
    `${apiBaseUri}${apiVersion}/document/get-by-id/${id}?project_id=${projectId}`,
  getAllDocuments: (type: string, projectId: string) =>
    `${apiBaseUri}${apiVersion}/document/get-by-type/${type}?project_id=${projectId}`,
  getSummaryList: (projectId: string) =>
    `${apiBaseUri}${apiVersion}/document/get-by-type/summary?project_id=${projectId}`,
  getSystemProposalList: (projectId: string) =>
    `${apiBaseUri}${apiVersion}/document/get-by-type/system-proposal?project_id=${projectId}`,
  getAllDocumentsInProject: (type: string, projectId: string) =>
    `${apiBaseUri}${apiVersion}/document/get-by-type/${type}?project_id=${projectId}`,
  getProject: (projectId: string, organizationId: string) =>
    `${apiBaseUri}${apiVersion}/project/${projectId}?organization_id=${organizationId}`,
  getRoleInProject: (id: string, userId: string, organizationId: string) =>
    `${apiBaseUri}${apiVersion}/project/${id}/role?user_id=${userId}&organization_id=${organizationId}`,
  getInvitableUsers: (id: string, organizationId: string) =>
    `${apiBaseUri}${apiVersion}/project/${id}/invitable-users?organization_id=${organizationId}`,
  inviteUserToOrganization: `${apiBaseUri}${apiVersion}/organization/invite`,
  inviteInternalUserToProject: `${apiBaseUri}${apiVersion}/project/invite-internal`,
  inviteExternalUserToProject: `${apiBaseUri}${apiVersion}/project/invite-external`,
  upsertVocaburary: `${apiBaseUri}${apiVersion}/project/dictionary`,
  generateAllFromSummary: `${apiBaseUri}${apiVersion}/generate-all-from-summary`,
  userInfoUpdate: `${apiBaseUri}${apiVersion}/user/update`,
  generateAllFromTranscribe: `${apiBaseUri}${apiVersion}/generate-all-from-transcribe`,
  updateProjectDetail: `${apiBaseUri}${apiVersion}/project/update`,
  generateFromTranscribe: `${apiBaseUri}${apiVersion}/generate-from-transcribe`,
  regenerateSystemProposal: `${apiBaseUri}${apiVersion}/regenerate-system-proposal`,
  generateFromSummary: `${apiBaseUri}${apiVersion}/generate-from-summary`,
  generateRequirements: `${apiBaseUri}${apiVersion}/generate-requirements`,
  generateArchitecture: `${apiBaseUri}${apiVersion}/generate-architecture`,
  deleteProject: (user_id: string, project_id: string, organization_id: string) =>
    `${apiBaseUri}${apiVersion}/project/${project_id}/delete?user=${user_id}&organization=${organization_id}`,
  logoutApp: `${apiBaseUri}/auth/logout`,
  getUserByEmail: `${apiBaseUri}${apiVersion}/user?email=sample@sample.com`,
  updateDocument: `${apiBaseUri}${apiVersion}/document/update`,
  lockDocument: `${apiBaseUri}${apiVersion}/document/lock`,
  unlockDocument: `${apiBaseUri}${apiVersion}/document/unlock`,
  updateDocumentInfo: `${apiBaseUri}${apiVersion}/document/update-info`,
  deleteDocument: (organization_id: string, project_id: string, id: string) =>
    `${apiBaseUri}${apiVersion}/document/${organization_id}/delete/${project_id}/${id}`,
  getCreditsPaginatedList: (organization_id: string, limit: number, page: number) =>
    `${apiBaseUri}${apiVersion}/organizations/${organization_id}/credits?limit=${limit}&page=${page}`,
  getReverseEngineeringReports: (organization_id: string, project_id: string) =>
    `${apiBaseUri}${apiVersion}/organizations/${organization_id}/projects/${project_id}/reverse-engineering/reports`,
  getReverseEngineeringReport: (organization_id: string, project_id: string, report_id: string) =>
    `${apiBaseUri}${apiVersion}/organizations/${organization_id}/projects/${project_id}/reverse-engineering/reports/${report_id}`,
  getKintoneAppsList: (organization_id: string, project_id: string) =>
    `${apiBaseUri}${apiVersion}/organizations/${organization_id}/projects/${project_id}/reverse-engineering/kintone-apps`,
  prepareReverseEngineering: (organization_id: string, project_id: string) =>
    `${apiBaseUri}${apiVersion}/organizations/${organization_id}/projects/${project_id}/reverse-engineering/prepare`,
  startAnalyzeReverseEngineering: (organization_id: string, project_id: string) =>
    `${apiBaseUri}${apiVersion}/organizations/${organization_id}/projects/${project_id}/reverse-engineering/analyze`,
  updateReverseEngineeringDocument: (
    organization_id: string,
    project_id: string,
    document_id: string,
  ) =>
    `${apiBaseUri}${apiVersion}/organizations/${organization_id}/projects/${project_id}/reverse-engineering/documents/${document_id}`,
  deleteReverseEngineeringReport: (
    organization_id: string,
    project_id: string,
    report_id: string,
  ) =>
    `${apiBaseUri}${apiVersion}/organizations/${organization_id}/projects/${project_id}/reverse-engineering/reports/${report_id}`,
  updateReverseEngineeringReportName: (
    organization_id: string,
    project_id: string,
    report_id: string,
  ) =>
    `${apiBaseUri}${apiVersion}/organizations/${organization_id}/projects/${project_id}/reverse-engineering/reports/${report_id}`,
  getInstanceStatus: (organization_id: string, project_id: string, df_instance_id: string) =>
    `${apiBaseUri}${apiVersion}/organizations/${organization_id}/projects/${project_id}/reverse-engineering/instances/${df_instance_id}/status`,
  getReverseEngineeringDocuments: (
    organization_id: string,
    project_id: string,
    parent_report_id: string,
  ) =>
    `${apiBaseUri}${apiVersion}/organizations/${organization_id}/projects/${project_id}/reverse-engineering/reports/${parent_report_id}/documents`,
  createReverseEngineeringProcessLock: (
    organization_id: string,
    project_id: string,
    document_id: string,
  ) =>
    `${apiBaseUri}${apiVersion}/organizations/${organization_id}/projects/${project_id}/reverse-engineering/documents/${document_id}/process-lock`,
  deleteReverseEngineeringProcessLock: (
    organization_id: string,
    project_id: string,
    document_id: string,
  ) =>
    `${apiBaseUri}${apiVersion}/organizations/${organization_id}/projects/${project_id}/reverse-engineering/documents/${document_id}/process-lock`,
  retryReverseEngineering: (organization_id: string, project_id: string, report_id: string) =>
    `${apiBaseUri}${apiVersion}/organizations/${organization_id}/projects/${project_id}/reverse-engineering/reports/${report_id}/retry`,
};

// No-code API base (backend/agents/nocode)
export const nocodeApiBaseUri = import.meta.env["VITE_NOCODE_API_BASE"] || "http://localhost:8001";
export const nocodeApiVersion = import.meta.env["VITE_NOCODE_API_VERSION"] || "/api/v1";
export const buildNocodeEndpoint = (path: string) =>
  `${nocodeApiBaseUri}${nocodeApiVersion}${path}`;

export const nocodeEndpoints = {
  workflowCreateJob: buildNocodeEndpoint(`/workflow/jobs`),
  workflowGetJob: (jobId: string) => buildNocodeEndpoint(`/workflow/jobs/${jobId}`),
  workflowGetJobLog: (jobId: string) => buildNocodeEndpoint(`/workflow/jobs/${jobId}/log`),
  // kintoneアプリ生成用エンドポイント
  getDeployedKintoneApps: (organizationId: string, projectId: string) =>
    buildNocodeEndpoint(`/organizations/${organizationId}/projects/${projectId}/kintone-apps`),
  // 開発ジョブ用エンドポイント
  createDevelopmentJob: (organizationId: string, projectId: string) =>
    buildNocodeEndpoint(`/organizations/${organizationId}/projects/${projectId}/development-jobs`),
  getDevelopmentJob: (organizationId: string, projectId: string, jobId: string) =>
    buildNocodeEndpoint(
      `/organizations/${organizationId}/projects/${projectId}/development-jobs/${jobId}`,
    ),
  getCurrentDevelopmentJob: (organizationId: string, projectId: string) =>
    buildNocodeEndpoint(
      `/organizations/${organizationId}/projects/${projectId}/development-jobs/current`,
    ),
  cancelDevelopmentJob: (organizationId: string, projectId: string, jobId: string) =>
    buildNocodeEndpoint(
      `/organizations/${organizationId}/projects/${projectId}/development-jobs/${jobId}/cancel`,
    ),
};
